/**
 * BlogSlugRouter.jsx — one smart route for /blog/:slug.
 * Platform posts (BookingFlows-authored) take precedence; if the slug isn't a
 * platform post it falls through to the operator blog page (org slug).
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Loader2 } from 'lucide-react';
import { BACKEND_URL } from '../config/api';
import PlatformBlogPostPage from './PlatformBlogPostPage';
import PublicBlogPage from './PublicBlogPage';

const probe = (url) => fetch(url).then((r) => ({ ok: r.ok }));

export default function BlogSlugRouter() {
  const { slug } = useParams();
  const { data, isLoading } = useSWR(
    slug ? `${BACKEND_URL}/api/v2/public/platform-blog/${slug}?probe=1` : null,
    probe,
    { revalidateOnFocus: false }
  );

  if (isLoading || !data) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
      </div>
    );
  }
  return data.ok ? <PlatformBlogPostPage /> : <PublicBlogPage />;
}
